import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';

export default class WorkOrderProcessDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.workOrderProcessId  = '';
		this.workOrderProcessWorkOrderProcessNumber = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.partName = '';
		this.partClassification = '';
		this.standarPackagingQty = '';
		this.billOfProcessId  = '';
		this.billOfProcessPartNumber = '';
		this.nextProcess = '';
		this.machineId  = '';
		this.machineCode = '';
		this.sph = '';
		this.qtyPlan = '';
		this.hourPlan = '';
		this.customer = '';
		this.remarkMultiple = '';
		this.documentStatusId  = '';
		this.documentStatusName = '';
		this.lotNo = '';
		this.isReference = false;
		this.isPrintLabel = false;
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
		this.documentStatus = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			workOrderProcessId : '0',
			workOrderProcessWorkOrderProcessNumber : '0',
			partId : '0',
			partPartNumber : '0',
			partName : '0',
			partClassification : '0',
			standarPackagingQty : '0',
			billOfProcessId : '0',
			billOfProcessPartNumber : '0',
			nextProcess : '0',
			machineId : '0',
			machineCode : '0',
			sph : '0',
			qtyPlan : '0',
			hourPlan : '0',
			customer : '0',
			remarkMultiple : '0',
			documentStatusId : '0',
			documentStatusName : '0',
			lotNo : '0',
			isReference : '0',
			isPrintLabel : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
			documentStatus: '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}